module.exports = __webpack_public_path__ + "static/media/inclusive-cross.570c7595.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inclusive-cross.svg
// module id = ./src/assets/images/inclusive-cross.svg
// module chunks = 0